var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckmarkNew(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 16,
    viewBox: "0 0 22 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.643772 8.20128C0.423555 7.93134 0.458494 7.53022 0.722117 7.30473C0.985742 7.08032 1.37748 7.11501 1.59664 7.38495L6.90297 13.8744L20.4504 0.708212C20.6982 0.466461 21.092 0.476216 21.3281 0.730978C21.5642 0.985739 21.5547 1.38794 21.3059 1.62969L7.29659 15.2438C7.28177 15.26 7.26694 15.2741 7.24895 15.2882C6.98532 15.5137 6.59358 15.4779 6.37442 15.208L0.643378 8.20044L0.643772 8.20128Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmarkNew);
export default __webpack_public_path__ + "static/media/checkmark-new.0452abbd6ca130db63f1eb1e2c9dd31f.svg";
export { ForwardRef as ReactComponent };